import React from "react"
import PropTypes from "prop-types"

import { ScrollFrameHeader } from "ui-ScrollFrame"
import CardContent from '@material-ui/core/CardContent';

const styleSheet = theme => ({
  root: {
    paddingLeft: theme.spacing.unit * 3,
    paddingRight: theme.spacing.unit * 3,
    paddingTop: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,

    [theme.breakpoints.down("xs")]: {
      paddingLeft: theme.spacing.unit,
      paddingRight: theme.spacing.unit,
    },
  },

  content: {
    "&:last-child": {
      paddingBottom: theme.spacing.unit * 2,
    },
  },

  gutterBottom: {
    paddingBottom: theme.spacing.unit * 3,
  },
})

function StaticDialogHeader({
  children,
  classes,
  className: classNameProp,
  gutterBottom,

  ...otherProps
}) {
  const className = classnames(
    classes.root,
    {
      [classes.gutterBottom]: gutterBottom,
    },
    classNameProp
  )

  return (
    <ScrollFrameHeader className={className} {...otherProps}>
      <CardContent className={classes.content}>{children}</CardContent>
    </ScrollFrameHeader>
  )
}

StaticDialogHeader.propTypes = {
  gutterBottom: PropTypes.bool,
}

import withStyles from "@material-ui/core/styles/withStyles"
import classnames from "classnames"

export default withStyles(styleSheet)(StaticDialogHeader)



// WEBPACK FOOTER //
// ../ui-kit/src/components/ui-StaticDialog/StaticDialogHeader.js